<mat-expansion-panel [expanded]="filters.expanded.firework_types" (opened)="opened()" (closed)="closed()">
    <mat-expansion-panel-header>
      <mat-panel-title>By Types</mat-panel-title>
    </mat-expansion-panel-header>
  <mat-checkbox color="primary" *ngFor="let firework_type of defaults.firework_types" (change)="toggle(firework_type.record.name, $event.checked)" [checked]="filters.firework_types.indexOf(firework_type.record.name)!==-1" [disabled]="firework_type.count === 0">{{ firework_type.record.name }} ({{ firework_type.count }})</mat-checkbox>
</mat-expansion-panel>
